export default __webpack_public_path__ + "static/slider1-e9014f091ce77f7737958ed9e3b2d490.png";